import React from 'react'
import styled from 'styled-components'
import { formatMoney } from 'utility/crm/dates'
import { Card, Muted } from './ui'

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    @media (max-width: 992px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`

const Tile = styled(Card)`
    text-align: left;
    color: inherit;
    font: inherit;
    .label {
        opacity: 0.7;
        font-size: 0.8rem;
    }
    .value {
        font-size: 1.5rem;
        font-weight: 700;
    }
`

const ClickableTile = styled(Tile).attrs({ as: 'button', type: 'button' })`
    cursor: pointer;
    width: 100%;
    ${({ $active }) => ($active ? 'border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.35);' : '')}
`

/**
 * Forecast numbers above the board. The Stuck tile toggles the stuck-only filter.
 * @param {{ forecast: import('utility/crm/types').CrmForecast|null, stuckDays: number, stuckOnly: boolean, onToggleStuck: () => void }} props
 */
export const ForecastStrip = ({ forecast, stuckDays, stuckOnly, onToggleStuck }) => {
    const f = forecast
    const dash = f ? null : '–'
    return (
        <Grid aria-label="Pipeline forecast" aria-busy={!f}>
            <Tile>
                <div className="label">Open pipeline</div>
                <div className="value">{dash ?? formatMoney(f.OpenAmount)}</div>
                <Muted>{f ? `${f.OpenCount} open deal${f.OpenCount === 1 ? '' : 's'}` : ''}</Muted>
            </Tile>
            <Tile>
                <div className="label">Weighted forecast</div>
                <div className="value">{dash ?? formatMoney(f.Weighted)}</div>
                <Muted>amount × stage win %</Muted>
            </Tile>
            <Tile>
                <div className="label">Closing this month</div>
                <div className="value">{dash ?? formatMoney(f.ClosingThisMonthAmount)}</div>
                <Muted>
                    {f ? `${f.ClosingThisMonthCount} deal${f.ClosingThisMonthCount === 1 ? '' : 's'}` : ''}
                    {f && f.PastCloseCount ? (
                        <>
                            {' · '}
                            <strong style={{ color: '#dc2626' }}>{f.PastCloseCount} past close date</strong>
                        </>
                    ) : null}
                </Muted>
            </Tile>
            <ClickableTile $active={stuckOnly} aria-pressed={stuckOnly} onClick={onToggleStuck}>
                <div className="label">Stuck deals (&gt;{stuckDays} days in stage)</div>
                <div className="value">{dash ?? f.StuckCount}</div>
                <Muted>{stuckOnly ? 'Showing only these. Click to show all' : 'Click to show only these'}</Muted>
            </ClickableTile>
        </Grid>
    )
}
